import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { App as AntdApp, ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import TrainingPage from './pages/TrainingPage';
import TrainingDetailPage from './pages/TrainingDetailPage';
import BookingPage from './pages/BookingPage';
import PromotionPage from './pages/PromotionPage';
import PromotionDetailPage from './pages/PromotionDetailPage';
import PromotionCategoryPage from './pages/PromotionCategoryPage';
import RecruitmentPage from './pages/RecruitmentPage';
import RecruitmentDetailPage from './pages/RecruitmentDetailPage';
import AboutUsPage from './pages/AboutUsPage';
import PressPage from './pages/PressPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import BranchesPage from './pages/BranchesPage';
import BranchDetailPage from './pages/BranchDetailPage';
import ServicesPage from './pages/ServicesPage';
import ServiceBaoDuongPage from './pages/ServiceBaoDuongPage';
import ServiceChamSocPage from './pages/ServiceChamSocPage';
import ServiceSonThanVoPage from './pages/ServiceSonThanVoPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import BlogPage from './pages/BlogPage';
import BlogBaoDuongPage from './pages/BlogBaoDuongPage';
import BlogTinTucPage from './pages/BlogTinTucPage';
import BlogKinhNghiemLaiXePage from './pages/BlogKinhNghiemLaiXePage';
import BlogCategoryPage from './pages/BlogCategoryPage';
import BlogDetailPage from './pages/BlogDetailPage';
import { DataProvider } from './context/DataContext';
import Fireworks from './components/Fireworks';
import ScrollToTop from './components/ScrollToTop';
import './index.css';

function App() {
    return (
        <ConfigProvider locale={viVN}>
            <AntdApp>
                <Fireworks />
                <DataProvider>
                    <Router>
                        <ScrollToTop />
                        <MainLayout>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/gioi-thieu/ve-chung-toi" element={<AboutUsPage />} />
                                <Route path="/gioi-thieu/bao-chi-noi-ve-ha-thanh" element={<PressPage />} />
                                <Route path="/su-kien" element={<EventsPage />} />
                                <Route path="/su-kien/:slug" element={<EventDetailPage />} />
                                <Route path="/gioi-thieu/he-thong-chi-nhanh" element={<BranchesPage />} />
                                <Route path="/he-thong-chi-nhanh/:slug" element={<BranchDetailPage />} />
                                <Route path="/dich-vu" element={<ServicesPage />} />
                                <Route path="/dich-vu/bao-duong-sua-chua" element={<ServiceBaoDuongPage />} />
                                <Route path="/dich-vu/cham-soc-lam-dep" element={<ServiceChamSocPage />} />
                                <Route path="/dich-vu/son-phuc-hoi-than-vo" element={<ServiceSonThanVoPage />} />
                                <Route path="/dich-vu/:slug" element={<ServiceDetailPage />} />
                                <Route path="/dich-vu-nhom/:slug" element={<ServicesPage />} />
                                <Route path="/blog" element={<BlogPage />} />
                                <Route path="/blog/kinh-nghiem-bao-duong" element={<BlogBaoDuongPage />} />
                                <Route path="/blog/tin-tuc-o-to" element={<BlogTinTucPage />} />
                                <Route path="/blog/kinh-nghiem-lai-xe" element={<BlogKinhNghiemLaiXePage />} />
                                <Route path="/blog/danh-muc/:categoryId" element={<BlogCategoryPage />} />
                                <Route path="/blog/:slug" element={<BlogDetailPage />} />
                                <Route path="/khuyen-mai" element={<PromotionPage />} />
                                <Route path="/khuyen-mai/danh-muc/:categoryId" element={<PromotionCategoryPage />} />
                                <Route path="/khuyen-mai/:slug" element={<PromotionDetailPage />} />
                                <Route path="/tuyen-dung" element={<RecruitmentPage />} />
                                <Route path="/tuyen-dung/:slug" element={<RecruitmentDetailPage />} />
                                <Route path="/lien-he" element={<ContactPage />} />
                                <Route path="/dao-tao" element={<TrainingPage />} />
                                <Route path="/dao-tao/:slug" element={<TrainingDetailPage />} />
                                <Route path="/dat-lich-hen" element={<BookingPage />} />
                            </Routes>
                        </MainLayout>
                    </Router>
                </DataProvider>
            </AntdApp>
        </ConfigProvider>
    );
}

export default App;





